<template>
  <div class="form-dlg">
    <el-dialog :title="isUpdate ? '编辑' : '新增'" :visible.sync="showDlg" width="60%" @open="openForm"
      @closed="closedForm">
      <div class="dialog-content">
        <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
          <el-form-item prop="categoryIds" label="商品类型:">
            <el-cascader v-model="formData.categoryIds" :options="categoryTypes" clearable
              :props="{ checkStrictly: true }"></el-cascader>
          </el-form-item>
          <el-form-item label="药剂类型:" prop="dosageForm">
            <el-input v-model="formData.dosageForm" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="内包装类型:" prop="packagingType">
            <el-input v-model="formData.packagingType" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="外包装类型:" prop="outerPackaging">
            <el-input v-model="formData.outerPackaging" clearable></el-input>
          </el-form-item>
          <el-form-item prop="productIngredients" label="产品配料:">
            <el-input v-model="formData.productIngredients" type="textarea"></el-input>
          </el-form-item>
          <el-form-item prop="targetPopulation" label="适用人群:">
            <el-input v-model="formData.targetPopulation" clearable></el-input>
          </el-form-item>
          <el-form-item label="内包装模板:" prop="packageList">
            <div v-if="formData.packageList && formData.packageList.length"
              style="display: flex;flex-direction: column;row-gap: 10px;">
              <div v-for="(item, index) in formData.packageList" :key="index"
                style="display: flex;align-items: center;column-gap: 10px;">
                <el-select v-model="item.id" style="width: 180px" clearable filterable>
                  <el-option v-for="(pItem, pIndex) in packList" :key="pIndex" :label="pItem.name" :value="pItem.id" />
                </el-select>
                <el-input v-model="item.outerSpecification" style="width: 180px;" />
                <el-button type="primary" circle icon="el-icon-plus" @click="formData.packageList.push({})"></el-button>
                <el-button type="danger" circle icon="el-icon-delete" style="margin-left: 0;"
                  v-if="formData.packageList.length > 1" @click="formData.packageList.splice(index, 1)"></el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$emit('change', false)">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="handleSubForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { add_update_solution, get_solution } from '@/api'

export default {
  name: 'form-dlg',
  model: {
    prop: 'value',
    event: 'change',
  },
  components: {},
  props: {
    value: Boolean,
    data: Object,
    categoryTypes: Array,
  },
  data() {
    return {
      loading: false,
      formData: {
        packageList: [{}],
      },
      rules: {
        categoryIds: [{ required: true, message: '请选择', trigger: 'change' }],
        dosageForm: [{ required: true, message: '请输入', trigger: 'change' }],
        packagingType: [{ required: true, message: '请输入', trigger: 'change' }],
        outerPackaging: [{ required: true, message: '请输入', trigger: 'change' }],
        productIngredients: [{ required: true, message: '请输入', trigger: 'change' }],
        targetPopulation: [{ required: true, message: '请输入', trigger: 'change' }],
        packageList: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      options: [],
      packList: [],
    }
  },
  computed: {
    showDlg: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('change', val)
      },
    },

    // 编辑模式
    isUpdate() {
      return this.data && (this.data.id || this.data.id === 0)
    },
  },
  watch: {},
  created() { },
  mounted() { },
  beforeDestroy() { },
  methods: {
    // 确定按钮
    handleSubForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const params = {
            ...this.formData,
            mainImage: this.formData?.mainImage?.map(item => item.url)?.join(','),
            scenarioImg: this.formData?.scenarioImg?.map(item => item.url),
            sellingImg: this.formData?.sellingImg?.map(item => item.url),
            certsImg: this.formData?.certsImg?.map(item => item.url)?.join(','),
          }
          this.addFormData(params)
        }
      })
    },

    // 重置表单
    resetForm() {
      this.$refs.form.resetFields()
    },

    // 弹窗打开
    openForm() {
      this.getPackList()
      if (this.isUpdate) {
        this.$nextTick(() => {
          this.getDet()
        })
      }
    },

    // 弹窗关闭动画结束
    closedForm() {
      this.resetForm()
    },

    getDet() {
      get_solution(this.data.id).then(res => {
        let data = res || {}

        if (!data.packageList || data.packageList.length == 0) {
          data.packageList = [{}]
        }
        this.formData = {
          ...data,
        }
      })
    },

    // 新增/更新
    addFormData(params) {
      this.loading = true
      add_update_solution(params)
        .then(res => {
          this.$message.success('操作成功')
          this.loading = false
          this.$emit('change', false)
          this.$emit('submit-form', res)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getPackList() {
      const res = await this.$request.post("/cms/productSolution/get_pack_list", {
        "size": 1000,
        "current": 0,
      })
      if (res.data.code == 200) {
        this.packList = res.data.data?.records || []
      }
    },
  },
}
</script>

<style lang="less" scoped>
.form-dlg {
  .dialog-content {
    overflow: auto;
    max-height: 50vh;
  }
}
</style>
